import React, { useCallback, useRef, useState } from 'react';
import { ButtonNewRecord, FlexRow, TableDataState, usePaginatedQueryV8 } from 'motion-components';
import { Card } from 'react-bootstrap';
import { useRootStore } from 'store';
import { useHandleError } from 'shared-pages/services';
import { gqlGetQuery } from '../graphql';
import { buildWhereFromFilterValues, Filters } from './filters';
import { DataGrid } from './grid';
import { handleExport } from './export-columns';
import { useApolloClient } from '@apollo/client';
import { getRouteByName } from 'app/routes';
import { generatePath, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { ImportExcel } from './import-from-excel';

/* ----------------------------------------------------------- */
/* ------------------------ Page ----------------------------- */
export const CollectionpointsGridPage = observer(
  ({
    collectionPointId,
    isGridInForm = false,
  }: {
    collectionPointId?: number;
    isGridInForm?: boolean;
  }) => {
    const { appStore, tableStore } = useRootStore();
    const { handleGraphqlError } = useHandleError('CollectionpointsGridPage');

    const location = useLocation<any>();
    const history = useHistory();
    const [selected, setSelected] = useState<any>(null);
    const { t } = useTranslation();

    // const { canView, canAddNew, canEdit, canDelete } = useUserLocationPermissions();
    const canAddNew =
      appStore.isPlatformOwner ||
      // (isRebatteryLiion && appStore.isContributor) ||
      appStore.isCollector;
    const canEdit =
      appStore.isPlatformOwner ||
      // (isRebatteryLiion && appStore.isContributor) ||
      appStore.isCollector;

    /* ------------------- Query ------------------------------- */
    const initOrderBy = 'name ASC';
    const query = usePaginatedQueryV8(
      gqlGetQuery,
      buildWhereFromFilterValues,
      location.state?.order ?? initOrderBy,
      appStore,
      true,
      { isActive: true, parentCpId: collectionPointId },
      !isGridInForm, // History Replace
      !isGridInForm ? undefined : 'coll_points_grid',
    );
    const {
      loading,
      data,
      dataCount,
      error,
      initPageIndex,
      filtersChanged,
      gridPageChanged,
      queryState,
      queryParams,
      setQueryParams,
      refetch,
    } = query;

    const client = useApolloClient();

    const canCreateNew = true;
    const handleCreateNew = useCallback(() => {
      history.push({
        pathname: generatePath(getRouteByName('Collectionpoint'), { id: -1 }),
        state: {
          pathname: location.pathname,
          ...location.state,
        },
      });
    }, [history, location.pathname, location.state]);

    const gridRef = useRef();
    if (error) {
      handleGraphqlError('query-get', error);
      return <h3 className="text-center">{error.message}</h3>;
    } else {
      return (
        <Card className="shadow">
          {!isGridInForm && (
            <Card.Header>
              <FlexRow>
                <Card.Title className="m-0">{t('Σημεία Συλλογής')}</Card.Title>
                {canAddNew && (
                  <ButtonNewRecord
                    onClick={handleCreateNew}
                    size="sm"
                    label="Νέο Σημείο Συλλογής"
                  />
                )}
              </FlexRow>
            </Card.Header>
          )}

          <Card.Body className="nopadding">
            {/* Φίλτρα */}
            <Filters
              onChange={filtersChanged}
              initialValues={queryState?.filterValues ?? {}}
              disable={tableStore.state !== TableDataState.browse}
              isGridInForm={isGridInForm}
            />
            {/* Grid */}
            <DataGrid
              ref={gridRef}
              loading={loading}
              data={data}
              dataCount={dataCount}
              initPageIndex={initPageIndex}
              onPageChange={gridPageChanged}
              handleExport={() => {
                handleExport(client, queryState, t);
              }}
              initOrderBy={queryParams?.order ?? initOrderBy}
              onOrderChange={(orderBy) => {
                const newQueryParams = { ...queryParams, order: orderBy };
                setQueryParams(newQueryParams);
                history.replace({
                  pathname: location.pathname,
                  state: {
                    ...location.state,
                    order: orderBy,
                  },
                });
              }}
              selected={selected}
              setSelected={setSelected}
              refetch={refetch}
              isGridInForm={isGridInForm}
              canEdit={canEdit}
              injectFooterElement={
                !isGridInForm && canAddNew ? <ImportExcel refetch={refetch} /> : undefined
              }
            />
          </Card.Body>
        </Card>
      );
    }
  },
);
